import React, { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import UndoOutlinedIcon from '@material-ui/icons/UndoOutlined';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import TextBox from 'UI/components/atoms/TextBox';
import { UIStatus } from 'UI/constants/status';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {number} props.itemId
 * @param {string} props.label
 * @param {string} props.name
 * @param {(string|number)} props.defaultValue
 * @param {Function} props.onCancel
 * @param {Function} props.onUpdate
 * @param {Function} props.updateAction
 */
const InlineEditField = ({
  itemId,
  name,
  label,
  defaultValue,
  onCancel,
  onUpdate,
  updateAction
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(defaultValue);
  const [status, setStatus] = useState(UIStatus.Default);

  const update = async () => {
    if (!updateAction || !value) return;

    setStatus(UIStatus.Loading);
    const result = await updateAction(itemId, { [name]: value });
    setStatus(UIStatus.Default);
    result.success && onUpdate(itemId, value);
  };

  const handleInputChange = (_, newValue) => {
    setStatus(newValue ? UIStatus.Default : UIStatus.Error);
    setValue(newValue);
  };

  const handleCancel = () => onCancel(itemId);

  const handleKeyDown = async e => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (e.key === 'Enter') {
        await update();
      } else {
        onCancel(itemId);
      }
    }
  };

  const isLoading = status === UIStatus.Loading;
  return (
    <div className={classes.container}>
      <TextBox
        name={name}
        label={label}
        value={value}
        onChange={handleInputChange}
        autoFocus
        onKeyDown={handleKeyDown}
        disabled={isLoading}
        error={status === UIStatus.Error}
      />
      <div className={classes.buttonsContainer}>
        <FPIconButton onClick={update} disabled={isLoading}>
          {isLoading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <CheckCircleOutlinedIcon color="primary" />
          )}
        </FPIconButton>
        <FPIconButton onClick={handleCancel} disabled={isLoading}>
          <UndoOutlinedIcon />
        </FPIconButton>
      </div>
    </div>
  );
};

InlineEditField.defaultProps = {};

export default InlineEditField;
